export const ACTION_SET_USER = 'SET_USER'
export const ACTION_SET_IS_MOBILE = 'SET_IS_MOBILE'
export const ACTION_SET_DEVICE = 'SET_DEVICE'
export const ACTION_SET_PROFILE_LEVEL = 'SET_PROFILE_LEVEL'
export const ACTION_SET_LAST_BLOCK_UPDATE = 'SET_LAST_BLOCK_UPDATE'
export const ACTION_SET_CONTACT_INFO = 'SET_CONTACT_INFO'
export const ACTION_SET_RESUME = 'SET_RESUME'
export const ACTION_SET_LIST_MORE_SECTION_LENGTH = 'SET_MORE_SECTION_LENGTH'
export const ACTION_SET_LIST_WORK_HISTORY = 'SET_LIST_WORK_HISTORY'
export const ACTION_SET_LANGUAGE = 'ACTION_SET_LANGUAGE'
export const ACTION_SET_BREAKPOINT = 'ACTION_SET_BREAKPOINT'
export const ACTION_SET_LIST_JOB_ALERT = 'ACTION_SET_LIST_JOB_ALERT'
export const ACTION_SET_RESUME_SETTING_INFO = 'SET_RESUME_SETTING_INFO'
export const ACTION_LOADING = 'ACTION_LOADING'
export const ACTION_FINISHED = 'ACTION_FINISHED'
export const ACTION_SET_BASIC_INFO = 'ACTION_SET_BASIC_INFO'
export const ACTION_SET_RECOMMENDATIONS = 'SET_RECOMMENDATION_LIST'
export const ACTION_SET_RECOMMENDATION_FROM_REFERENCE = 'SET_RECOMMENDATION_FROM_REFERENCE'
export const ACTION_SET_RESUME_DETAIL = 'ACTION_SET_RESUME_DETAIL'
export const ACTION_SHOW_SETTING_PROFILE = 'ACTION_SHOW_SETTING_PROFILE'
